import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/image1.png';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-[#0033A0] text-white sticky top-0 z-50 shadow-lg">
      <div className="max-w-6xl mx-auto flex justify-between items-center p-4">
        {/* Logo + Nombre */}
        <div className="flex items-center space-x-4">
          <img src={logo} alt="Logo" className="w-40 h-auto object-contain" />
          <span className="text-2xl sm:text-3xl font-bold tracking-wide">La Tapatía El Grullo</span>
        </div>

        {/* Botón del menú (mobile) */}
        <button
          className="sm:hidden text-white focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Menú (desktop) */}
        <nav className="hidden sm:flex space-x-6 text-base">
          <Link to="/" className="hover:underline">Nosotros</Link>
          <Link to="/productos" className="hover:underline">Productos</Link>
          <Link to="/servicios" className="hover:underline">Servicios</Link>
          <Link to="/galeria" className="hover:underline">Galería</Link>
          <Link to="/contacto" className="hover:underline">Contacto</Link>
        </nav>
      </div>

      {/* Menú despegable (mobile) */}
      {menuOpen && (
        <div className="sm:hidden bg-[#0033A0]/95 backdrop-blur-md text-white px-6 py-4 transition-all duration-300">
          <ul className="space-y-3 text-lg">
            <li>
              <Link to="/" className="block hover:text-yellow-300" onClick={() => setMenuOpen(false)}>
                Nosotros
              </Link>
            </li>
            <li>
              <Link to="/productos" className="block hover:text-yellow-300" onClick={() => setMenuOpen(false)}>
                Productos
              </Link>
            </li>
            <li>
              <Link to="/servicios" className="block hover:text-yellow-300" onClick={() => setMenuOpen(false)}>
                Servicios
              </Link>
            </li>
            <li>
              <Link to="/galeria" className="block hover:text-yellow-300" onClick={() => setMenuOpen(false)}>
                Galería
              </Link>
            </li>
            <li>
              <Link to="/contacto" className="block hover:text-yellow-300" onClick={() => setMenuOpen(false)}>
                Contacto
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
